import { getPeriodPageUrl } from '@constants'
import { useBusinessContext } from '@context'
import { IPeriod } from '@query'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled, { useTheme } from 'styled-components'
import { DateProgressListLink } from '../../components/DateProgressListItem'
import { DateProgressItem } from '../../components/DateProgressItem'

interface Props {
  period: IPeriod
  isSelected: boolean
  isFirstOfType: boolean
  isLastOfType: boolean
  height: number
}

export const PeriodListItem: React.FC<Props> = ({
  period,
  isSelected,
  isFirstOfType,
  isLastOfType,
  height
}) => {
  const [t] = useTranslation()
  const { slug } = useBusinessContext()
  const theme = useTheme()

  const itemUrl = useMemo(
    () =>
      getPeriodPageUrl(slug, {
        id: period.id
      }),
    [period.id, slug]
  )

  return (
    <StyledItemWrapper $itemHeight={height}>
      <StyledListItem
        to={itemUrl}
        $isSelected={isSelected}
        $isFirstOfType={isFirstOfType}
        $isLastOfType={isLastOfType}
      >
        <FlatDateProgressItem
          appearance="flat"
          dateFrom={new Date(period.start_date)}
          dateTo={new Date(period.end_date)}
          titleFrom={t('period.form.startDate')}
          titleTo={t('period.form.endDate')}
          progressColor={percent => {
            if (period.is_locked) {
              return theme.colors.success
            } else if (percent < 100) {
              return theme.colors.primary
            } else {
              return theme.colors.warning
            }
          }}
        />
      </StyledListItem>
    </StyledItemWrapper>
  )
}

const StyledItemWrapper = styled.div<{ $itemHeight: number }>`
  height: ${({ $itemHeight }) => $itemHeight}px;
`

const StyledListItem = styled(DateProgressListLink).attrs({
  onClick: e => {
    if (e.shiftKey || e.metaKey) {
      e.preventDefault()
    }
  },
  'data-test': 'accounting-period-list-item'
})``

const FlatDateProgressItem = styled(DateProgressItem)`
  width: 100%;
  height: 100%;
`
